import { CSSProperties } from "react";
import styled from "@emotion/styled";

export type ButtonSplitProps = {
  // What element type the hidden element will be. Done so most fragment usage will work
  secondaryType: "a" | "button";
  width?: CSSProperties["width"];
};

/**
 * Provide 2 children, first element will always be visible and the second will only show on hover.
 *
 * This isn't animated by default since there isn't a way to append properties in CSS.
 * You may need to add `min-width: 0` to the first element if it overflows to get it to work
 * @argument secondaryType HTML type of the element which should be hidden
 */
const ButtonSplit = styled.div<ButtonSplitProps>(({ secondaryType, width }) => ({
  display: "flex",
  flexDirection: "row",
  gap: "8px",
  width,

  // We want the second element to be hidden by default and only show on hover OR keyboard navigation focus (via tabbing)
  // The second element should also continue to show if it's open (e.g. a dropdown)
  // Due to a bug in Chromium https://issues.chromium.org/issues/439339105, we have to make this more complex than needed
  // to avoid breaking keyboard navigation. Once the bug is fixed replace the selector with the following:
  // `&:not(:hover):not(:has(:focus-visible)) > ${secondaryType}:last-child:not([data-state=open])`
  [`&:not(:hover):not(:focus-within) > ${secondaryType}:last-child:not([data-state=open]), & > ${secondaryType}:last-child:focus:not([data-state=open]):not(:focus-visible)`]:
    {
      display: "none",
    },
}));

export default ButtonSplit;
